import { render, staticRenderFns } from "./PastEvents.vue?vue&type=template&id=96be57a6&scoped=true"
import script from "./PastEvents.vue?vue&type=script&lang=js"
export * from "./PastEvents.vue?vue&type=script&lang=js"
import style0 from "./PastEvents.vue?vue&type=style&index=0&id=96be57a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96be57a6",
  null
  
)

export default component.exports